import { Reveal } from "../Reveal";
import { IMAGES } from "../../lib/data";

export const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative bg-[#0a0a0a] py-24 sm:py-36"
    >
      <div className="mx-auto max-w-[1500px] px-5 sm:px-8 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <div className="lg:col-span-7">
          <Reveal>
            <p className="flex items-center gap-3 text-xs font-bold uppercase tracking-[0.3em] text-[#e62429] mb-8">
              <span className="h-px w-10 bg-[#e62429]" /> About
            </p>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="font-display uppercase text-white text-4xl sm:text-6xl lg:text-7xl leading-[0.9]">
              We design, operate <br className="hidden sm:block" /> and activate{" "}
              <span className="text-stroke">experiences</span> that move people.
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-8 max-w-xl text-lg text-neutral-300 leading-relaxed">
              From strategy to scale, we build meaningful experiences in sport,
              events and beyond. Nineteen years of designing and running
              competitive events across sports, formats and levels.
            </p>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="mt-10 inline-flex items-center gap-4 border border-white/15 px-6 py-4">
              <span className="font-display text-2xl text-white">
                OWNED BY PURPOSE.
              </span>
              <span className="font-display text-2xl text-[#e62429]">
                DRIVEN BY PASSION.
              </span>
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-5">
          <Reveal delay={0.1} y={60}>
            <div className="relative aspect-[3/4] overflow-hidden">
              <img
                src={IMAGES.about}
                alt="Athlete on the track"
                className="h-full w-full object-cover grayscale hover:grayscale-0 transition-[filter] duration-700"
              />
              <div className="absolute inset-0 ring-1 ring-inset ring-white/10" />
              <div className="absolute bottom-0 left-0 bg-[#e62429] px-5 py-3">
                <span className="font-display text-xl text-white">19 YEARS</span>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
